<div class="cutId" *ngIf="user$ | async as user">
  <span class="custName" matTooltipClass="vs-tooltip" matTooltipPosition="below"
    matTooltip="{{ user?.orgUnit?.name }}">{{ user?.orgUnit?.name }} </span> | {{ user?.orgUnit?.uid }}

  <br>
  <div class="entity">
    <div class="legalEntity mr-1">
      {{user?.recentSalesArea?.salesOrganization}}
    </div> <!-- {{user?.recentSalesArea?.salesAreaAddress?.formattedAddress}} -->
    ({{ user?.recentSalesArea?.uid }}) | {{ customerCurrency?.isocode }}
    ({{ customerCurrency?.symbol }})
  </div>
  <span *ngIf="displayChangeAccount" class="change" (click)="openDetail()">{{ "userData.changeAccount" | cxTranslate }}</span>
</div>
<div *ngIf="showSideNav">
  <vs-change-cust-account id="sideNav" (closeSideNav)="closeSideNav($event)" [width]="width"></vs-change-cust-account>
</div>